import Crud from './crud'
import { export_list } from '@/commons/hpod';
var FileSaver = require('file-saver');
var crud = new Crud('receipts', 'đơn xuất');

const state = {
    ...crud.state,
    selected: {
        id: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    export_excel({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list("receipts", res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
            FileSaver.saveAs(blob, `DonXuat_${new Date().getTime()}.xlsx`);
        }, param, this.state.authentication.token, 'export');
    },
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};